import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (path) => {
  const token = localStorage.getItem("token");
  return `${API}/files/${path}?auth=${token}`;
};

export const money = (v) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", minimumFractionDigits: 2 }).format(v || 0);

export const concreteDiff = (c) =>
  (Number(c.note_balance) || 0) - (Number(c.concrete_total) || 0);

export const coladoTotal = (c) => {
  let t = (Number(c.m2) || 0) * (Number(c.price_per_m2) || 0) + (Number(c.extra_amount) || 0);
  if (c.concrete_apply) t -= concreteDiff(c);
  return t;
};

export const DAYS = ["lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"];
export const DAY_LABEL = {
  lunes: "Lunes", martes: "Martes", miercoles: "Miércoles", jueves: "Jueves",
  viernes: "Viernes", sabado: "Sábado", domingo: "Domingo",
};

export default api;
